module.exports = __webpack_public_path__ + "static/media/play.a51b6ebc.svg";